import { FormikProps } from "formik";
import { AccordionRoot } from "../Accordion";
import { KlientkontoerklaeringTexts } from "./texts";
import { IsCompleteHelpers } from "./util/isComplete";
import { useRef } from "react";
import {
  Revisors0Intro,
  RevisorsHandling1,
  RevisorsHandling2,
  RevisorsHandling3,
  RevisorsHandling4,
  RevisorsHandling5,
  RevisorsHandling6,
  RevisorsHandling7,
  RevisorsHandling8,
  RevisorsHandling9,
  RevisorsHandling10,
  RevisorsHandling11,
  RevisorsHandling12,
  RevisorsHandling13,
  RevisorsHandling14,
  RevisorsHandling15,
  RevisorsHandling16,
  RevisorsOevrigeOplysninger,
} from "./RevisorsErklaering/index";
import { KlientkontoerklaeringFormValues } from "../../interfaces/klientkontoerklaering";

export interface RevisorsSectionProps {
  texts: KlientkontoerklaeringTexts;
  isCompleteHelpers: IsCompleteHelpers;
  formikProps: FormikProps<KlientkontoerklaeringFormValues>;
  refs: ReturnType<typeof useHeaderRefs>;
  locked?: boolean;
}

export default function RevisorsErklaering(props: {
  texts: KlientkontoerklaeringTexts;
  formikProps: FormikProps<KlientkontoerklaeringFormValues>;
  isCompleteHelpers: IsCompleteHelpers;
  locked?: boolean;
}) {
  const { formikProps, texts, isCompleteHelpers, locked } = props;
  const { advokatens_complete } = isCompleteHelpers;
  const refs = useHeaderRefs();
  const sectionProps: RevisorsSectionProps = {
    formikProps,
    isCompleteHelpers,
    refs,
    texts,
    locked,
  };

  return (
    <>
      {!advokatens_complete && (
        <div className="card-body border-bottom">
          <div className="callout callout-danger" role="alert">
            "Advokatens/Advokatselskabets erklæring" skal udfyldes færdig, inden
            du kan gå videre.
          </div>
        </div>
      )}
      <AccordionRoot
        defaultValue={["Indledning"]}
        type="single"
        className={`${locked ? "disabled" : ""}`}
      >
        <Revisors0Intro {...sectionProps} />
        <RevisorsHandling1 {...sectionProps} />
        <RevisorsHandling2 {...sectionProps} />
        <RevisorsHandling3 {...sectionProps} />
        <RevisorsHandling4 {...sectionProps} />
        <RevisorsHandling5 {...sectionProps} />
        <RevisorsHandling6 {...sectionProps} />
        <RevisorsHandling7 {...sectionProps} />
        <RevisorsHandling8 {...sectionProps} />
        <RevisorsHandling9 {...sectionProps} />
        <RevisorsHandling10 {...sectionProps} />
        <RevisorsHandling11 {...sectionProps} />
        <RevisorsHandling12 {...sectionProps} />
        <RevisorsHandling13 {...sectionProps} />
        <RevisorsHandling14 {...sectionProps} />
        <RevisorsHandling15 {...sectionProps} />
        <RevisorsHandling16 {...sectionProps} />
        <RevisorsOevrigeOplysninger {...sectionProps} />
      </AccordionRoot>
    </>
  );
}

const useHeaderRefs = () => {
  const introRef = useRef<HTMLHeadingElement>(null);
  const handling_1_ref = useRef<HTMLHeadingElement>(null);
  const handling_2_ref = useRef<HTMLHeadingElement>(null);
  const handling_3_ref = useRef<HTMLHeadingElement>(null);
  const handling_4_ref = useRef<HTMLHeadingElement>(null);
  const handling_5_ref = useRef<HTMLHeadingElement>(null);
  const handling_6_ref = useRef<HTMLHeadingElement>(null);
  const handling_7_ref = useRef<HTMLHeadingElement>(null);
  const handling_8_ref = useRef<HTMLHeadingElement>(null);
  const handling_9_ref = useRef<HTMLHeadingElement>(null);
  const handling_10_ref = useRef<HTMLHeadingElement>(null);
  const handling_11_ref = useRef<HTMLHeadingElement>(null);
  const handling_12_ref = useRef<HTMLHeadingElement>(null);
  const handling_13_ref = useRef<HTMLHeadingElement>(null);
  const handling_14_ref = useRef<HTMLHeadingElement>(null);
  const handling_15_ref = useRef<HTMLHeadingElement>(null);
  const handling_16_ref = useRef<HTMLHeadingElement>(null);
  return {
    introRef,
    handling_1_ref,
    handling_2_ref,
    handling_3_ref,
    handling_4_ref,
    handling_5_ref,
    handling_6_ref,
    handling_7_ref,
    handling_8_ref,
    handling_9_ref,
    handling_10_ref,
    handling_11_ref,
    handling_12_ref,
    handling_13_ref,
    handling_14_ref,
    handling_15_ref,
    handling_16_ref,
  };
};

export const scrollToRefIfNotInView = (
  ref: React.RefObject<HTMLElement | null>,
) => {
  setTimeout(() => {
    if (ref.current) {
      const { top, bottom } = ref.current.getBoundingClientRect();
      if (top < 0 || bottom > window.innerHeight) {
        // need extra offset due to tab bar
        window.scrollTo(0, window.scrollY + top - 58);
      }
    }
  }, 300);
};
